export default __webpack_public_path__ + "static/media/feet.a44cf81b.png";